var resources = require('items-view-strings');
    var strings = resources['_JpOeb9ugaJtoG8GZr07Q1A'];
export { strings };
export default strings;
